import React from 'react';

const Application = () => {
    return (
        <>
            <h1>Welcome to Credit Documents</h1>
        </>
    );
};
export default Application;
